@file:OptIn(InternalResourceApi::class)

package showcaseapp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/showcaseapp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-528_512_348)
internal val Res.string.ai_profile_error_url_invalid: StringResource by lazy {
      StringResource("string:ai_profile_error_url_invalid", "ai_profile_error_url_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5356, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6388, 140),
      ))
    }

@delegate:ResourceContentHash(1_665_719_676)
internal val Res.string.ai_profile_in_use: StringResource by lazy {
      StringResource("string:ai_profile_in_use", "ai_profile_in_use", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5509, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6529, 49),
      ))
    }

@delegate:ResourceContentHash(1_758_554_975)
internal val Res.string.ai_profile_name: StringResource by lazy {
      StringResource("string:ai_profile_name", "ai_profile_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5559, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6579, 39),
      ))
    }

@delegate:ResourceContentHash(1_443_948_288)
internal val Res.string.ai_profile_save: StringResource by lazy {
      StringResource("string:ai_profile_save", "ai_profile_save", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5607, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6619, 39),
      ))
    }

@delegate:ResourceContentHash(1_182_731_888)
internal val Res.string.ai_profile_selector: StringResource by lazy {
      StringResource("string:ai_profile_selector", "ai_profile_selector", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5655, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6659, 51),
      ))
    }

@delegate:ResourceContentHash(862_958_012)
internal val Res.string.ai_provider: StringResource by lazy {
      StringResource("string:ai_provider", "ai_provider", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6156, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7164, 31),
      ))
    }

@delegate:ResourceContentHash(-1_010_632_096)
internal val Res.string.ai_provider_deepseek_vision: StringResource by lazy {
      StringResource("string:ai_provider_deepseek_vision", "ai_provider_deepseek_vision", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5711, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6711, 47),
      ))
    }

@delegate:ResourceContentHash(-1_899_125_088)
internal val Res.string.ai_provider_gemini: StringResource by lazy {
      StringResource("string:ai_provider_gemini", "ai_provider_gemini", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5813, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6813, 62),
      ))
    }

@delegate:ResourceContentHash(1_869_720_416)
internal val Res.string.ai_provider_gemini_vision: StringResource by lazy {
      StringResource("string:ai_provider_gemini_vision", "ai_provider_gemini_vision", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5759, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6759, 53),
      ))
    }

@delegate:ResourceContentHash(-804_377_920)
internal val Res.string.ai_provider_openai: StringResource by lazy {
      StringResource("string:ai_provider_openai", "ai_provider_openai", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5938, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6938, 34),
      ))
    }

@delegate:ResourceContentHash(1_672_842_141)
internal val Res.string.ai_provider_openai_vision: StringResource by lazy {
      StringResource("string:ai_provider_openai_vision", "ai_provider_openai_vision", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5876, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6876, 61),
      ))
    }

@delegate:ResourceContentHash(1_406_807_980)
internal val Res.string.ai_provider_sent_prompt: StringResource by lazy {
      StringResource("string:ai_provider_sent_prompt", "ai_provider_sent_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 5973, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6973, 79),
      ))
    }

@delegate:ResourceContentHash(1_084_892_670)
internal val Res.string.ai_provider_settings_title: StringResource by lazy {
      StringResource("string:ai_provider_settings_title", "ai_provider_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6057, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7053, 58),
      ))
    }

@delegate:ResourceContentHash(-1_612_122_377)
internal val Res.string.ai_provider_unknown: StringResource by lazy {
      StringResource("string:ai_provider_unknown", "ai_provider_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6112, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7112, 51),
      ))
    }

@delegate:ResourceContentHash(539_028_175)
internal val Res.string.ai_retry: StringResource by lazy {
      StringResource("string:ai_retry", "ai_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6341, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7369, 40),
      ))
    }

@delegate:ResourceContentHash(1_758_060_081)
internal val Res.string.ai_retry_unknown_warning: StringResource by lazy {
      StringResource("string:ai_retry_unknown_warning", "ai_retry_unknown_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6196, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7196, 172),
      ))
    }

@delegate:ResourceContentHash(1_364_561_625)
internal val Res.string.ai_save_generated_to_album: StringResource by lazy {
      StringResource("string:ai_save_generated_to_album", "ai_save_generated_to_album", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6382, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7410, 54),
      ))
    }

@delegate:ResourceContentHash(-30_210_536)
internal val Res.string.ai_save_original_to_album: StringResource by lazy {
      StringResource("string:ai_save_original_to_album", "ai_save_original_to_album", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6437, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7465, 53),
      ))
    }

@delegate:ResourceContentHash(-133_039_365)
internal val Res.string.ai_saved_profile: StringResource by lazy {
      StringResource("string:ai_saved_profile", "ai_saved_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6487, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7519, 44),
      ))
    }

@delegate:ResourceContentHash(-1_762_328_436)
internal val Res.string.ai_service_info_disclaimer_body: StringResource by lazy {
      StringResource("string:ai_service_info_disclaimer_body", "ai_service_info_disclaimer_body", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_service_info.commonMain.cvr", 247, 443),
        ResourceItem(setOf(), "${MD}values/ai_service_info.commonMain.cvr", 239, 463),
      ))
    }

@delegate:ResourceContentHash(-13_008_924)
internal val Res.string.ai_service_info_disclaimer_title: StringResource by lazy {
      StringResource("string:ai_service_info_disclaimer_title", "ai_service_info_disclaimer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_service_info.commonMain.cvr", 691, 56),
        ResourceItem(setOf(), "${MD}values/ai_service_info.commonMain.cvr", 703, 56),
      ))
    }

@delegate:ResourceContentHash(2_009_596_994)
internal val Res.string.ai_service_info_photos_body: StringResource by lazy {
      StringResource("string:ai_service_info_photos_body", "ai_service_info_photos_body", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_service_info.commonMain.cvr", 748, 251),
        ResourceItem(setOf(), "${MD}values/ai_service_info.commonMain.cvr", 760, 259),
      ))
    }

@delegate:ResourceContentHash(-810_429_443)
internal val Res.string.ai_service_info_photos_title: StringResource by lazy {
      StringResource("string:ai_service_info_photos_title", "ai_service_info_photos_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_service_info.commonMain.cvr", 1000, 52),
        ResourceItem(setOf(), "${MD}values/ai_service_info.commonMain.cvr", 1020, 64),
      ))
    }

@delegate:ResourceContentHash(1_041_802_843)
internal val Res.string.ai_service_info_security_body: StringResource by lazy {
      StringResource("string:ai_service_info_security_body", "ai_service_info_security_body", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_service_info.commonMain.cvr", 1053, 317),
        ResourceItem(setOf(), "${MD}values/ai_service_info.commonMain.cvr", 1085, 353),
      ))
    }

@delegate:ResourceContentHash(761_311_734)
internal val Res.string.ai_service_info_security_title: StringResource by lazy {
      StringResource("string:ai_service_info_security_title", "ai_service_info_security_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_service_info.commonMain.cvr", 1371, 62),
        ResourceItem(setOf(), "${MD}values/ai_service_info.commonMain.cvr", 1439, 62),
      ))
    }

@delegate:ResourceContentHash(-672_034_418)
internal val Res.string.ai_service_info_title: StringResource by lazy {
      StringResource("string:ai_service_info_title", "ai_service_info_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_service_info.commonMain.cvr", 1434, 69),
        ResourceItem(setOf(), "${MD}values/ai_service_info.commonMain.cvr", 1502, 73),
      ))
    }

@delegate:ResourceContentHash(-1_383_727_582)
internal val Res.string.ai_share_failed: StringResource by lazy {
      StringResource("string:ai_share_failed", "ai_share_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 386, 59),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 402, 59),
      ))
    }

@delegate:ResourceContentHash(2_113_691_241)
internal val Res.string.ai_show_generated: StringResource by lazy {
      StringResource("string:ai_show_generated", "ai_show_generated", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6532, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7564, 37),
      ))
    }

@delegate:ResourceContentHash(-315_339_077)
internal val Res.string.ai_show_original: StringResource by lazy {
      StringResource("string:ai_show_original", "ai_show_original", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6570, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7602, 36),
      ))
    }

@delegate:ResourceContentHash(-1_554_439_439)
internal val Res.string.ai_source_image_description: StringResource by lazy {
      StringResource("string:ai_source_image_description", "ai_source_image_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6603, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7639, 51),
      ))
    }

@delegate:ResourceContentHash(1_819_178_605)
internal val Res.string.ai_stage_downloading_result: StringResource by lazy {
      StringResource("string:ai_stage_downloading_result", "ai_stage_downloading_result", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6647, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7691, 59),
      ))
    }

@delegate:ResourceContentHash(791_054_368)
internal val Res.string.ai_stage_generating: StringResource by lazy {
      StringResource("string:ai_stage_generating", "ai_stage_generating", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6707, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7751, 43),
      ))
    }

@delegate:ResourceContentHash(-1_235_694_744)
internal val Res.string.ai_stage_persisting_result: StringResource by lazy {
      StringResource("string:ai_stage_persisting_result", "ai_stage_persisting_result", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6751, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7795, 54),
      ))
    }

@delegate:ResourceContentHash(-1_283_294_530)
internal val Res.string.ai_stage_preparing_input: StringResource by lazy {
      StringResource("string:ai_stage_preparing_input", "ai_stage_preparing_input", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6810, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7850, 52),
      ))
    }

@delegate:ResourceContentHash(1_743_237_578)
internal val Res.string.ai_stage_uploading: StringResource by lazy {
      StringResource("string:ai_stage_uploading", "ai_stage_uploading", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6867, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7903, 38),
      ))
    }

@delegate:ResourceContentHash(804_343_123)
internal val Res.string.ai_stage_validating: StringResource by lazy {
      StringResource("string:ai_stage_validating", "ai_stage_validating", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6910, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7942, 59),
      ))
    }

@delegate:ResourceContentHash(-259_589_750)
internal val Res.string.ai_status_cancelled: StringResource by lazy {
      StringResource("string:ai_status_cancelled", "ai_status_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 6962, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8002, 39),
      ))
    }

@delegate:ResourceContentHash(-1_162_109_709)
internal val Res.string.ai_status_failed: StringResource by lazy {
      StringResource("string:ai_status_failed", "ai_status_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7002, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8042, 48),
      ))
    }

@delegate:ResourceContentHash(2_033_549_861)
internal val Res.string.ai_status_needs_user_action: StringResource by lazy {
      StringResource("string:ai_status_needs_user_action", "ai_status_needs_user_action", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7043, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8091, 55),
      ))
    }

@delegate:ResourceContentHash(1_140_850_664)
internal val Res.string.ai_status_queued: StringResource by lazy {
      StringResource("string:ai_status_queued", "ai_status_queued", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7095, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8147, 32),
      ))
    }

@delegate:ResourceContentHash(201_987_121)
internal val Res.string.ai_status_result_unknown: StringResource by lazy {
      StringResource("string:ai_status_result_unknown", "ai_status_result_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7132, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8180, 52),
      ))
    }

@delegate:ResourceContentHash(-1_784_093_508)
internal val Res.string.ai_status_retry_wait: StringResource by lazy {
      StringResource("string:ai_status_retry_wait", "ai_status_retry_wait", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7181, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8233, 52),
      ))
    }

@delegate:ResourceContentHash(791_054_368)
internal val Res.string.ai_status_running: StringResource by lazy {
      StringResource("string:ai_status_running", "ai_status_running", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7226, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8286, 41),
      ))
    }

@delegate:ResourceContentHash(1_587_666_697)
internal val Res.string.ai_status_succeeded: StringResource by lazy {
      StringResource("string:ai_status_succeeded", "ai_status_succeeded", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7268, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8328, 55),
      ))
    }

@delegate:ResourceContentHash(1_666_019_464)
internal val Res.string.ai_style_artcomic_description: StringResource by lazy {
      StringResource("string:ai_style_artcomic_description", "ai_style_artcomic_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7312, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8384, 129),
      ))
    }

@delegate:ResourceContentHash(-1_107_459_067)
internal val Res.string.ai_style_artcomic_name: StringResource by lazy {
      StringResource("string:ai_style_artcomic_name", "ai_style_artcomic_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7430, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8514, 50),
      ))
    }

@delegate:ResourceContentHash(-761_385_828)
internal val Res.string.ai_style_clay_description: StringResource by lazy {
      StringResource("string:ai_style_clay_description", "ai_style_clay_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7485, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8565, 121),
      ))
    }

@delegate:ResourceContentHash(-1_991_452_843)
internal val Res.string.ai_style_clay_name: StringResource by lazy {
      StringResource("string:ai_style_clay_name", "ai_style_clay_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7595, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8687, 46),
      ))
    }

@delegate:ResourceContentHash(-773_323_993)
internal val Res.string.ai_style_cyberpunk_description: StringResource by lazy {
      StringResource("string:ai_style_cyberpunk_description", "ai_style_cyberpunk_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7642, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8734, 142),
      ))
    }

@delegate:ResourceContentHash(-163_700_268)
internal val Res.string.ai_style_cyberpunk_name: StringResource by lazy {
      StringResource("string:ai_style_cyberpunk_name", "ai_style_cyberpunk_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7769, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8877, 43),
      ))
    }

@delegate:ResourceContentHash(-1_817_259_810)
internal val Res.string.ai_style_ghibli_description: StringResource by lazy {
      StringResource("string:ai_style_ghibli_description", "ai_style_ghibli_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7821, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8921, 123),
      ))
    }

@delegate:ResourceContentHash(-18_437_161)
internal val Res.string.ai_style_ghibli_name: StringResource by lazy {
      StringResource("string:ai_style_ghibli_name", "ai_style_ghibli_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7921, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9045, 44),
      ))
    }

@delegate:ResourceContentHash(797_449_518)
internal val Res.string.ai_style_oilpainting_description: StringResource by lazy {
      StringResource("string:ai_style_oilpainting_description", "ai_style_oilpainting_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 7974, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9090, 132),
      ))
    }

@delegate:ResourceContentHash(774_844_584)
internal val Res.string.ai_style_oilpainting_name: StringResource by lazy {
      StringResource("string:ai_style_oilpainting_name", "ai_style_oilpainting_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8099, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9223, 69),
      ))
    }

@delegate:ResourceContentHash(-298_387_107)
internal val Res.string.ai_style_pixar_description: StringResource by lazy {
      StringResource("string:ai_style_pixar_description", "ai_style_pixar_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8153, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9293, 126),
      ))
    }

@delegate:ResourceContentHash(1_675_868_423)
internal val Res.string.ai_style_pixar_name: StringResource by lazy {
      StringResource("string:ai_style_pixar_name", "ai_style_pixar_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8264, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9420, 39),
      ))
    }

@delegate:ResourceContentHash(-434_525_715)
internal val Res.string.ai_style_sketch_description: StringResource by lazy {
      StringResource("string:ai_style_sketch_description", "ai_style_sketch_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8316, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9460, 127),
      ))
    }

@delegate:ResourceContentHash(-1_527_026_167)
internal val Res.string.ai_style_sketch_name: StringResource by lazy {
      StringResource("string:ai_style_sketch_name", "ai_style_sketch_name", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8416, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9588, 48),
      ))
    }

@delegate:ResourceContentHash(-1_488_172_929)
internal val Res.string.ai_summary_archive_count: StringResource by lazy {
      StringResource("string:ai_summary_archive_count", "ai_summary_archive_count", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 10, 80),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 10, 68),
      ))
    }

@delegate:ResourceContentHash(1_146_126_173)
internal val Res.string.ai_summary_archive_description: StringResource by lazy {
      StringResource("string:ai_summary_archive_description", "ai_summary_archive_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 91, 170),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 79, 190),
      ))
    }

@delegate:ResourceContentHash(-859_872_210)
internal val Res.string.ai_summary_archive_legacy: StringResource by lazy {
      StringResource("string:ai_summary_archive_legacy", "ai_summary_archive_legacy", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 262, 189),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 270, 185),
      ))
    }

@delegate:ResourceContentHash(-599_093_114)
internal val Res.string.ai_summary_archive_title: StringResource by lazy {
      StringResource("string:ai_summary_archive_title", "ai_summary_archive_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 452, 56),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 456, 68),
      ))
    }

@delegate:ResourceContentHash(-84_326_927)
internal val Res.string.ai_summary_cancel: StringResource by lazy {
      StringResource("string:ai_summary_cancel", "ai_summary_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 509, 33),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 525, 33),
      ))
    }

@delegate:ResourceContentHash(349_710_960)
internal val Res.string.ai_summary_document_continue: StringResource by lazy {
      StringResource("string:ai_summary_document_continue", "ai_summary_document_continue", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 543, 52),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 559, 56),
      ))
    }

@delegate:ResourceContentHash(-2_126_239_970)
internal val Res.string.ai_summary_export: StringResource by lazy {
      StringResource("string:ai_summary_export", "ai_summary_export", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1598, 33),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 1702, 33),
      ))
    }

@delegate:ResourceContentHash(1_110_689_325)
internal val Res.string.ai_summary_export_archive_explanation: StringResource by lazy {
      StringResource("string:ai_summary_export_archive_explanation", "ai_summary_export_archive_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 596, 113),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 616, 133),
      ))
    }

@delegate:ResourceContentHash(579_091_156)
internal val Res.string.ai_summary_export_csv_complete: StringResource by lazy {
      StringResource("string:ai_summary_export_csv_complete", "ai_summary_export_csv_complete", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 710, 66),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 750, 66),
      ))
    }

@delegate:ResourceContentHash(571_600_330)
internal val Res.string.ai_summary_export_csv_explanation: StringResource by lazy {
      StringResource("string:ai_summary_export_csv_explanation", "ai_summary_export_csv_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 777, 141),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 817, 161),
      ))
    }

@delegate:ResourceContentHash(549_541_833)
internal val Res.string.ai_summary_export_diagnostics: StringResource by lazy {
      StringResource("string:ai_summary_export_diagnostics", "ai_summary_export_diagnostics", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 919, 101),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 979, 117),
      ))
    }

@delegate:ResourceContentHash(342_538_045)
internal val Res.string.ai_summary_export_explanation: StringResource by lazy {
      StringResource("string:ai_summary_export_explanation", "ai_summary_export_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1021, 229),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 1097, 253),
      ))
    }

@delegate:ResourceContentHash(819_543_302)
internal val Res.string.ai_summary_export_failed: StringResource by lazy {
      StringResource("string:ai_summary_export_failed", "ai_summary_export_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1251, 124),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 1351, 144),
      ))
    }

@delegate:ResourceContentHash(1_797_036_416)
internal val Res.string.ai_summary_export_format_archive: StringResource by lazy {
      StringResource("string:ai_summary_export_format_archive", "ai_summary_export_format_archive", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1376, 84),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 1496, 80),
      ))
    }

@delegate:ResourceContentHash(-413_757_915)
internal val Res.string.ai_summary_export_format_csv: StringResource by lazy {
      StringResource("string:ai_summary_export_format_csv", "ai_summary_export_format_csv", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1461, 64),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 1577, 52),
      ))
    }

@delegate:ResourceContentHash(1_550_439_021)
internal val Res.string.ai_summary_exported: StringResource by lazy {
      StringResource("string:ai_summary_exported", "ai_summary_exported", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1526, 71),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 1630, 71),
      ))
    }

@delegate:ResourceContentHash(1_449_418_895)
internal val Res.string.ai_summary_import: StringResource by lazy {
      StringResource("string:ai_summary_import", "ai_summary_import", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1933, 33),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 2057, 33),
      ))
    }

@delegate:ResourceContentHash(-846_568_072)
internal val Res.string.ai_summary_import_failed: StringResource by lazy {
      StringResource("string:ai_summary_import_failed", "ai_summary_import_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1632, 176),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 1736, 200),
      ))
    }

@delegate:ResourceContentHash(-1_527_144_458)
internal val Res.string.ai_summary_imported: StringResource by lazy {
      StringResource("string:ai_summary_imported", "ai_summary_imported", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/summary_archive.commonMain.cvr", 1809, 123),
        ResourceItem(setOf(), "${MD}values/summary_archive.commonMain.cvr", 1937, 119),
      ))
    }

@delegate:ResourceContentHash(-392_274_377)
internal val Res.string.ai_summary_preview_autumn_description: StringResource by lazy {
      StringResource("string:ai_summary_preview_autumn_description", "ai_summary_preview_autumn_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 854, 145),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1046, 149),
      ))
    }

@delegate:ResourceContentHash(-1_144_644_396)
internal val Res.string.ai_summary_preview_city_description: StringResource by lazy {
      StringResource("string:ai_summary_preview_city_description", "ai_summary_preview_city_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1000, 147),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1196, 135),
      ))
    }

@delegate:ResourceContentHash(34_885_926)
internal val Res.string.ai_summary_preview_description: StringResource by lazy {
      StringResource("string:ai_summary_preview_description", "ai_summary_preview_description", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1148, 146),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1332, 138),
      ))
    }

@delegate:ResourceContentHash(1_754_646_782)
internal val Res.string.ai_summary_preview_example: StringResource by lazy {
      StringResource("string:ai_summary_preview_example", "ai_summary_preview_example", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1295, 58),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1471, 62),
      ))
    }

@delegate:ResourceContentHash(-842_209_569)
internal val Res.string.ai_summary_preview_next_narration: StringResource by lazy {
      StringResource("string:ai_summary_preview_next_narration", "ai_summary_preview_next_narration", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1354, 65),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1534, 73),
      ))
    }

@delegate:ResourceContentHash(-1_572_639_023)
internal val Res.string.ai_summary_preview_tag_autumn: StringResource by lazy {
      StringResource("string:ai_summary_preview_tag_autumn", "ai_summary_preview_tag_autumn", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1420, 45),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1608, 45),
      ))
    }

@delegate:ResourceContentHash(320_108_769)
internal val Res.string.ai_summary_preview_tag_branches: StringResource by lazy {
      StringResource("string:ai_summary_preview_tag_branches", "ai_summary_preview_tag_branches", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1466, 47),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1654, 51),
      ))
    }

@delegate:ResourceContentHash(-648_632_463)
internal val Res.string.ai_summary_preview_tag_light: StringResource by lazy {
      StringResource("string:ai_summary_preview_tag_light", "ai_summary_preview_tag_light", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1514, 44),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1706, 60),
      ))
    }

@delegate:ResourceContentHash(-1_796_320_910)
internal val Res.string.ai_summary_preview_tag_street: StringResource by lazy {
      StringResource("string:ai_summary_preview_tag_street", "ai_summary_preview_tag_street", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1559, 45),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1767, 45),
      ))
    }

@delegate:ResourceContentHash(1_812_426_018)
internal val Res.string.ai_summary_preview_tag_sunset: StringResource by lazy {
      StringResource("string:ai_summary_preview_tag_sunset", "ai_summary_preview_tag_sunset", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1605, 45),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1813, 45),
      ))
    }

@delegate:ResourceContentHash(-294_300_492)
internal val Res.string.ai_summary_preview_tag_water: StringResource by lazy {
      StringResource("string:ai_summary_preview_tag_water", "ai_summary_preview_tag_water", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_summary_preview.commonMain.cvr", 1651, 44),
        ResourceItem(setOf(), "${MD}values/ai_summary_preview.commonMain.cvr", 1859, 60),
      ))
    }

@delegate:ResourceContentHash(-1_585_026_793)
internal val Res.string.ai_task_detail_title: StringResource by lazy {
      StringResource("string:ai_task_detail_title", "ai_task_detail_title", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8465, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9637, 52),
      ))
    }

@delegate:ResourceContentHash(319_222_255)
internal val Res.string.ai_task_load_failed: StringResource by lazy {
      StringResource("string:ai_task_load_failed", "ai_task_load_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8510, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9690, 67),
      ))
    }

@delegate:ResourceContentHash(654_558_643)
internal val Res.string.ai_tasks: StringResource by lazy {
      StringResource("string:ai_tasks", "ai_tasks", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_creation_details.commonMain.cvr", 269, 24),
        ResourceItem(setOf(), "${MD}values/ai_creation_details.commonMain.cvr", 293, 24),
      ))
    }

@delegate:ResourceContentHash(-633_125_310)
internal val Res.string.ai_token: StringResource by lazy {
      StringResource("string:ai_token", "ai_token", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8643, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9839, 28),
      ))
    }

@delegate:ResourceContentHash(-890_767_794)
internal val Res.string.ai_token_leave_blank: StringResource by lazy {
      StringResource("string:ai_token_leave_blank", "ai_token_leave_blank", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8578, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9758, 80),
      ))
    }

@delegate:ResourceContentHash(-384_870_148)
internal val Res.string.ai_understanding_profile_required: StringResource by lazy {
      StringResource("string:ai_understanding_profile_required", "ai_understanding_profile_required", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8672, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9868, 133),
      ))
    }

@delegate:ResourceContentHash(887_020_467)
internal val Res.string.ai_upload_snapshot_notice: StringResource by lazy {
      StringResource("string:ai_upload_snapshot_notice", "ai_upload_snapshot_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/ai_gallery.commonMain.cvr", 446, 137),
        ResourceItem(setOf(), "${MD}values/ai_gallery.commonMain.cvr", 462, 153),
      ))
    }

@delegate:ResourceContentHash(1_745_643_624)
internal val Res.string.album: StringResource by lazy {
      StringResource("string:album", "album", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9977, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11237, 21),
      ))
    }

@delegate:ResourceContentHash(-294_250_041)
internal val Res.string.album_apple_web_unsupported: StringResource by lazy {
      StringResource("string:album_apple_web_unsupported", "album_apple_web_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8790, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10002, 215),
      ))
    }

@delegate:ResourceContentHash(1_498_669_344)
internal val Res.string.album_generated_name_apple: StringResource by lazy {
      StringResource("string:album_generated_name_apple", "album_generated_name_apple", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9045, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10289, 54),
      ))
    }

@delegate:ResourceContentHash(-1_017_146_722)
internal val Res.string.album_generated_name_apple_default: StringResource by lazy {
      StringResource("string:album_generated_name_apple_default", "album_generated_name_apple_default", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 8978, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10218, 70),
      ))
    }

@delegate:ResourceContentHash(1_172_302_899)
internal val Res.string.album_generated_name_default: StringResource by lazy {
      StringResource("string:album_generated_name_default", "album_generated_name_default", setOf(
        ResourceItem(setOf(LanguageQualifier("zh"), RegionQualifier("CN"), ), "${MD}values-zh-rCN/strings.commonMain.cvr", 9100, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10344, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("ai_profile_error_url_invalid", Res.string.ai_profile_error_url_invalid)
  map.put("ai_profile_in_use", Res.string.ai_profile_in_use)
  map.put("ai_profile_name", Res.string.ai_profile_name)
  map.put("ai_profile_save", Res.string.ai_profile_save)
  map.put("ai_profile_selector", Res.string.ai_profile_selector)
  map.put("ai_provider", Res.string.ai_provider)
  map.put("ai_provider_deepseek_vision", Res.string.ai_provider_deepseek_vision)
  map.put("ai_provider_gemini", Res.string.ai_provider_gemini)
  map.put("ai_provider_gemini_vision", Res.string.ai_provider_gemini_vision)
  map.put("ai_provider_openai", Res.string.ai_provider_openai)
  map.put("ai_provider_openai_vision", Res.string.ai_provider_openai_vision)
  map.put("ai_provider_sent_prompt", Res.string.ai_provider_sent_prompt)
  map.put("ai_provider_settings_title", Res.string.ai_provider_settings_title)
  map.put("ai_provider_unknown", Res.string.ai_provider_unknown)
  map.put("ai_retry", Res.string.ai_retry)
  map.put("ai_retry_unknown_warning", Res.string.ai_retry_unknown_warning)
  map.put("ai_save_generated_to_album", Res.string.ai_save_generated_to_album)
  map.put("ai_save_original_to_album", Res.string.ai_save_original_to_album)
  map.put("ai_saved_profile", Res.string.ai_saved_profile)
  map.put("ai_service_info_disclaimer_body", Res.string.ai_service_info_disclaimer_body)
  map.put("ai_service_info_disclaimer_title", Res.string.ai_service_info_disclaimer_title)
  map.put("ai_service_info_photos_body", Res.string.ai_service_info_photos_body)
  map.put("ai_service_info_photos_title", Res.string.ai_service_info_photos_title)
  map.put("ai_service_info_security_body", Res.string.ai_service_info_security_body)
  map.put("ai_service_info_security_title", Res.string.ai_service_info_security_title)
  map.put("ai_service_info_title", Res.string.ai_service_info_title)
  map.put("ai_share_failed", Res.string.ai_share_failed)
  map.put("ai_show_generated", Res.string.ai_show_generated)
  map.put("ai_show_original", Res.string.ai_show_original)
  map.put("ai_source_image_description", Res.string.ai_source_image_description)
  map.put("ai_stage_downloading_result", Res.string.ai_stage_downloading_result)
  map.put("ai_stage_generating", Res.string.ai_stage_generating)
  map.put("ai_stage_persisting_result", Res.string.ai_stage_persisting_result)
  map.put("ai_stage_preparing_input", Res.string.ai_stage_preparing_input)
  map.put("ai_stage_uploading", Res.string.ai_stage_uploading)
  map.put("ai_stage_validating", Res.string.ai_stage_validating)
  map.put("ai_status_cancelled", Res.string.ai_status_cancelled)
  map.put("ai_status_failed", Res.string.ai_status_failed)
  map.put("ai_status_needs_user_action", Res.string.ai_status_needs_user_action)
  map.put("ai_status_queued", Res.string.ai_status_queued)
  map.put("ai_status_result_unknown", Res.string.ai_status_result_unknown)
  map.put("ai_status_retry_wait", Res.string.ai_status_retry_wait)
  map.put("ai_status_running", Res.string.ai_status_running)
  map.put("ai_status_succeeded", Res.string.ai_status_succeeded)
  map.put("ai_style_artcomic_description", Res.string.ai_style_artcomic_description)
  map.put("ai_style_artcomic_name", Res.string.ai_style_artcomic_name)
  map.put("ai_style_clay_description", Res.string.ai_style_clay_description)
  map.put("ai_style_clay_name", Res.string.ai_style_clay_name)
  map.put("ai_style_cyberpunk_description", Res.string.ai_style_cyberpunk_description)
  map.put("ai_style_cyberpunk_name", Res.string.ai_style_cyberpunk_name)
  map.put("ai_style_ghibli_description", Res.string.ai_style_ghibli_description)
  map.put("ai_style_ghibli_name", Res.string.ai_style_ghibli_name)
  map.put("ai_style_oilpainting_description", Res.string.ai_style_oilpainting_description)
  map.put("ai_style_oilpainting_name", Res.string.ai_style_oilpainting_name)
  map.put("ai_style_pixar_description", Res.string.ai_style_pixar_description)
  map.put("ai_style_pixar_name", Res.string.ai_style_pixar_name)
  map.put("ai_style_sketch_description", Res.string.ai_style_sketch_description)
  map.put("ai_style_sketch_name", Res.string.ai_style_sketch_name)
  map.put("ai_summary_archive_count", Res.string.ai_summary_archive_count)
  map.put("ai_summary_archive_description", Res.string.ai_summary_archive_description)
  map.put("ai_summary_archive_legacy", Res.string.ai_summary_archive_legacy)
  map.put("ai_summary_archive_title", Res.string.ai_summary_archive_title)
  map.put("ai_summary_cancel", Res.string.ai_summary_cancel)
  map.put("ai_summary_document_continue", Res.string.ai_summary_document_continue)
  map.put("ai_summary_export", Res.string.ai_summary_export)
  map.put("ai_summary_export_archive_explanation", Res.string.ai_summary_export_archive_explanation)
  map.put("ai_summary_export_csv_complete", Res.string.ai_summary_export_csv_complete)
  map.put("ai_summary_export_csv_explanation", Res.string.ai_summary_export_csv_explanation)
  map.put("ai_summary_export_diagnostics", Res.string.ai_summary_export_diagnostics)
  map.put("ai_summary_export_explanation", Res.string.ai_summary_export_explanation)
  map.put("ai_summary_export_failed", Res.string.ai_summary_export_failed)
  map.put("ai_summary_export_format_archive", Res.string.ai_summary_export_format_archive)
  map.put("ai_summary_export_format_csv", Res.string.ai_summary_export_format_csv)
  map.put("ai_summary_exported", Res.string.ai_summary_exported)
  map.put("ai_summary_import", Res.string.ai_summary_import)
  map.put("ai_summary_import_failed", Res.string.ai_summary_import_failed)
  map.put("ai_summary_imported", Res.string.ai_summary_imported)
  map.put("ai_summary_preview_autumn_description", Res.string.ai_summary_preview_autumn_description)
  map.put("ai_summary_preview_city_description", Res.string.ai_summary_preview_city_description)
  map.put("ai_summary_preview_description", Res.string.ai_summary_preview_description)
  map.put("ai_summary_preview_example", Res.string.ai_summary_preview_example)
  map.put("ai_summary_preview_next_narration", Res.string.ai_summary_preview_next_narration)
  map.put("ai_summary_preview_tag_autumn", Res.string.ai_summary_preview_tag_autumn)
  map.put("ai_summary_preview_tag_branches", Res.string.ai_summary_preview_tag_branches)
  map.put("ai_summary_preview_tag_light", Res.string.ai_summary_preview_tag_light)
  map.put("ai_summary_preview_tag_street", Res.string.ai_summary_preview_tag_street)
  map.put("ai_summary_preview_tag_sunset", Res.string.ai_summary_preview_tag_sunset)
  map.put("ai_summary_preview_tag_water", Res.string.ai_summary_preview_tag_water)
  map.put("ai_task_detail_title", Res.string.ai_task_detail_title)
  map.put("ai_task_load_failed", Res.string.ai_task_load_failed)
  map.put("ai_tasks", Res.string.ai_tasks)
  map.put("ai_token", Res.string.ai_token)
  map.put("ai_token_leave_blank", Res.string.ai_token_leave_blank)
  map.put("ai_understanding_profile_required", Res.string.ai_understanding_profile_required)
  map.put("ai_upload_snapshot_notice", Res.string.ai_upload_snapshot_notice)
  map.put("album", Res.string.album)
  map.put("album_apple_web_unsupported", Res.string.album_apple_web_unsupported)
  map.put("album_generated_name_apple", Res.string.album_generated_name_apple)
  map.put("album_generated_name_apple_default", Res.string.album_generated_name_apple_default)
  map.put("album_generated_name_default", Res.string.album_generated_name_default)
}
